module.exports = __webpack_public_path__ + "img/tech_image_2_1.6736c762.jpg";